import reportFrontendIncident from './reportFrontendIncident';

/**
 * Installs global runtime-error handlers ONCE. Imperative (not a React hook) so
 * it needs no change to App.js — call it from index.js before rendering.
 * Captures uncaught window errors, resource-load failures and unhandled promise
 * rejections and forwards them to the watchdog.
 */

let installed = false;

function messageOf(errorLike, fallback) {
	if (!errorLike) return fallback;
	if (typeof errorLike === 'string') return errorLike;
	if (typeof errorLike.message === 'string' && errorLike.message) return errorLike.message;
	try {
		return JSON.stringify(errorLike);
	} catch (_) {
		return String(errorLike);
	}
}

function stackOf(errorLike) {
	return errorLike && typeof errorLike === 'object' && typeof errorLike.stack === 'string'
		? errorLike.stack
		: null;
}

export default function installGlobalErrorReporting() {
	if (installed || typeof window === 'undefined') {
		return;
	}
	installed = true;

	window.addEventListener(
		'error',
		(event) => {
			const resourceUrl = event?.target?.src || event?.target?.href || null;
			const isResourceError = !!resourceUrl && !event.error;
			reportFrontendIncident({
				type: isResourceError ? 'resource-load-error' : 'window-error',
				message: messageOf(event.error || event.message, 'Unhandled window error'),
				stack: stackOf(event.error),
				metadata: {
					filename: event.filename || null,
					lineno: event.lineno || null,
					colno: event.colno || null,
					resource_url: resourceUrl,
				},
			});
		},
		true
	);

	window.addEventListener('unhandledrejection', (event) => {
		const reason = event?.reason;
		reportFrontendIncident({
			type: 'unhandled-rejection',
			message: messageOf(reason, 'Unhandled promise rejection'),
			stack: stackOf(reason),
			metadata: { reason_type: reason?.name || typeof reason },
		});
	});
}
